import React from 'react';
// import ReactMarkdown from 'react-markdown';
import './index.css';
// import 'github-markdown-css/github-markdown.css'
import global from '../../http/common';
import markdownIt from 'markdown-it'

const md = new markdownIt();
class MyMarkdown extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      markdownText: '',
      defaultHeight: 500
    }
  }
  componentWillMount () {
  }
  componentDidMount () {
  }
  changeMarkdownText (text) {
    // console.log(text);
    this.setState({ markdownText: text });
  }
  render () {
    let html = this.state.markdownText ? md.render(this.state.markdownText) : null;
    if (html) {
      html = global.escapeDecode(html);
    }
    return (
      <div className="myMarkdown" style={{ height: this.state.markdownText == "" ? this.state.defaultHeight + "px" : "" }}>
        <div
          className="article-detail"
          dangerouslySetInnerHTML={{
            __html: html
          }}
        />
      </div>
    );
  }
}
export default MyMarkdown;